// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-main-wallet[data-v-5e9a12dc] {\n  color: #fbc913;\n}\n.font-10[data-v-5e9a12dc] {\n  font-size: 10px;\n}\n.v-list-item--dense .v-list-item__title[data-v-5e9a12dc],\n.v-list-item--dense .v-list-item__subtitle[data-v-5e9a12dc],\n.v-list--dense .v-list-item .v-list-item__title[data-v-5e9a12dc],\n.v-list--dense .v-list-item .v-list-item__subtitle[data-v-5e9a12dc] {\n  font-size: 10px;\n  line-height: 1.2;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
